module.exports = __webpack_public_path__ + "img/listria_b1.4af55549.jpg";